import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {INeodataBtns} from '../../../../core/models/interfaces/generico-interface';
import { IgxButtonDirective, IgxButtonModule, IgxToggleActionDirective, IgxToggleDirective } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IGX_DROP_DOWN_DIRECTIVES, IgxDropDownModule } from '@infragistics/igniteui-angular/drop-down';
import {EnumMasOpciones} from '../../../../core/models/enum/enum-mas-opciones';
import {ClsConfig} from '../../../../util/cls-config';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-mas-opciones-grid',
  templateUrl: './mas-opciones-grid.component.html',
  styleUrls: ['./mas-opciones-grid.component.scss'],
  imports: [
    IgxIconComponent,
    IgxButtonModule,
    IgxButtonDirective,
    TranslateModule,
    IgxDropDownModule,
    IGX_DROP_DOWN_DIRECTIVES,
    IgxToggleActionDirective
  ]
})
export class MasOpcionesGridComponent extends ClsConfig implements OnInit {
  @ViewChild(IgxToggleDirective, {static: true}) public igxToggle: IgxToggleDirective;
  @ViewChild('button', {static: true}) public igxButton: ElementRef;

  /**
   * 0 = Ajustar
   * 1 = Exportar
   * 2 = Exportar PDF
   * 3 = Actualizar
   * 4 = Expandir
   * 5 = Colapsar
   * 6 = Limpiar filtro
   */
  @Input()
  public arrayDatosAVer: number[] = [];
  @Output()
  public opcionSeleccionada: EventEmitter<string> = new EventEmitter<string>();

  public btnsGrid: INeodataBtns[];
  public btnsGridTemp: INeodataBtns[];

  constructor() {
    super();
    this.btnsGridTemp = [
      {
        id:0,
        icon: 'wrap_text',
        text: EnumMasOpciones.Ajustar
      },
      {
        id:1,
        icon: 'file_download',
        text: EnumMasOpciones.ExportarExcel
      },
      {
        id:2,
        icon: 'picture_as_pdf',
        text: EnumMasOpciones.ExportarPDF
      },
      {
        id:3,
        icon: 'update',
        text: EnumMasOpciones.Actualizar
      },
      {
        id:4,
        icon: 'expand_more',
        text: EnumMasOpciones.Expandir
      },
      {
        id:5,
        icon: 'chevron_right',
        text: EnumMasOpciones.Colapsar
      },
      {
        id:6,
        icon: 'highlight_off',
        text: EnumMasOpciones.LimpiarFiltroColumnas
      },
    ];
  }

  ngOnInit(): void {
    this.filtrarDatosAVer();
  }

  public filtrarDatosAVer() {
    this.btnsGrid = [];
    this.btnsGridTemp.filter((value, index) => {
      this.arrayDatosAVer.find(value2 => {
        if (value2 === index) {
          this.btnsGrid.push({id:0, icon: value.icon, text: value.text});
        }
      });
    });
  }

  public onSelectionDropDown(opcion: string) {
    this.opcionSeleccionada.emit(opcion);
  }

}
